import { Validator } from 'jsonschema';
import { productSchema } from './Schemas';

const validateProductFiles = (files, callback) => {
    let metaFile = findMetaFile(files);

    if (metaFile !== null && metaFile !== undefined) {
        parseMetaFile(metaFile, (metadata) => {
            if (metadata == undefined || metadata == null) {
                callback({
                    filesToUpload: [],
                    metadata: {},
                    isValid: false,
                    errorMessage: 'The metadata provided is invalid, please supply correct metadata for this product.'
                });
            } else {
                let filteredFiles = files.filter(function (i) {
                    return i !== metaFile;
                });
    
                let missingFiles = checkForRequiredFiles(metadata, filteredFiles.map((file) => file.name));
    
                var errorMessage = '';
                if (missingFiles !== undefined && missingFiles.length > 0) {
                    errorMessage = 'Missing file' + (missingFiles.length > 1 ? 's: ' : ': ') + missingFiles.join(', ') + '. Please add to continue';
                }
    
                callback({
                    filesToUpload: filteredFiles,
                    metadata: metadata,
                    isValid: missingFiles.length > 0 ? false : true,
                    errorMessage: errorMessage
                });
            }
        });
    } else {
        callback({
            filesToUpload: [],
            metadata: {},
            isValid: false,
            errorMessage: 'Missing metadata file'
        });
    }
};

const checkForRequiredFiles = (metadata, files) => {
    var filenamesToCheck = [];
    filenamesToCheck.push(metadata.model);
    filenamesToCheck.push(metadata['preview-image']);
    filenamesToCheck.push(...parseTextureFiles(metadata['textures']));

    return checkFileNamesExist(filenamesToCheck, files);
};

const parseTextureFiles = (textureData) => {
    var accessoryFileNames = [];
    if(textureData != null && textureData != undefined) {
        for (let texture of textureData) {
            accessoryFileNames.push(texture.name);
        }
    }
    return accessoryFileNames;
};


const checkFileNamesExist = (fileNamesToCheck, uploadedFileNames) => {
    var missingFileNames = [];
    for (let filename of fileNamesToCheck) {
        if (!uploadedFileNames.includes(filename)) {
            missingFileNames.push(filename);
        }
    }
    return missingFileNames;
};

const parseMetaFile = (metaFile, callback) => {
    var reader = new FileReader();

    reader.onload = function() {
        let jsonData = JSON.parse(reader.result);
        if(validateJSON(jsonData)) {
            callback(jsonData);
        } else {
            callback();
        }
    };

    reader.readAsText(metaFile);
};



const validateJSON = (jsonData) => {
    var v = new Validator();
    return v.validate(jsonData, productSchema).errors.length == 0;
};

const findMetaFile = (files) => {
    for (let file of files) {
        let fileNameComponents = file.name.split('.').map(String);
        let extension = fileNameComponents[fileNameComponents.length - 1];
        if(extension === 'json' || extension === 'JSON') {
            return file;
        }
    }
};

export { validateProductFiles };


// WEBPACK FOOTER //
// ./src/validation/ProductValidation.js